/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseBranch } from '../models/BaseBranch';
import type { BaseProvider } from '../models/BaseProvider';
import type { Body_add_provider_picture_latest_sp_providers_provider__provider_id__add_picture_patch } from '../models/Body_add_provider_picture_latest_sp_providers_provider__provider_id__add_picture_patch';
import type { Body_add_provider_picture_v1_sp_providers_provider__provider_id__add_picture_patch } from '../models/Body_add_provider_picture_v1_sp_providers_provider__provider_id__add_picture_patch';
import type { BranchEdit } from '../models/BranchEdit';
import type { BranchIn } from '../models/BranchIn';
import type { BranchListOutSchema } from '../models/BranchListOutSchema';
import type { BranchWithDepartments } from '../models/BranchWithDepartments';
import type { GenericStatus } from '../models/GenericStatus';
import type { OrderByProvidersEnum } from '../models/OrderByProvidersEnum';
import type { ProviderEdit } from '../models/ProviderEdit';
import type { ProviderIn } from '../models/ProviderIn';
import type { SimpleBranch } from '../models/SimpleBranch';
import type { SimpleBranchWithCompletionStatus } from '../models/SimpleBranchWithCompletionStatus';
import type { SimpleProvider } from '../models/SimpleProvider';
import type { UserLocationIn } from '../models/UserLocationIn';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SPProvidersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Providers
     * @param nameSearch
     * @param orderBy
     * @param showInactive
     * @param orderAscending
     * @param limit
     * @param offset
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetProviders(
        nameSearch?: (string | null),
        orderBy?: (OrderByProvidersEnum | null),
        showInactive: boolean = true,
        orderAscending: boolean = true,
        limit: number = 30,
        offset?: number,
    ): CancelablePromise<Array<SimpleProvider>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/providers',
            query: {
                'name_search': nameSearch,
                'order_by': orderBy,
                'show_inactive': showInactive,
                'order_ascending': orderAscending,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider
     * @param providerId
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetProvider(
        providerId: number,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/provider/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Provider
     * @param providerId
     * @param requestBody
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public patchSPProvidersEditProvider(
        providerId: number,
        requestBody: ProviderEdit,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/provider/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Provider
     * @param providerId
     * @returns GenericStatus Successful Response
     * @throws ApiError
     */
    public deleteSPProvidersDeleteProvider(
        providerId: number,
    ): CancelablePromise<GenericStatus> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/sp/providers/provider/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider Active Or Inactive
     * @param providerId
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetProviderActiveOrInactive(
        providerId: number,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/provider/{provider_id}/active_or_inactive',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider Detailed
     * @param providerId
     * @returns BaseProvider Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetProviderDetailed(
        providerId: number,
    ): CancelablePromise<BaseProvider> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/provider/{provider_id}/detailed',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branches From Provider
     * ### Get the branches of a provider.
     *
     * This endpoint is used to get the branches of a provider. It is paginated and returns a list of branches.
     *
     * Args:
     * - `provider_id`: The id of the provider to get the branches from.
     * - `limit`: The number of branches to return.
     * - `offset`: The number of branches to skip.
     *
     * Returns:
     * - A list of branches in `BranchListOutSchema` model.
     * @param providerId
     * @param limit
     * @param offset
     * @param branchName
     * @returns BranchListOutSchema Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetBranchesFromProvider(
        providerId: number,
        limit: number = 30,
        offset?: number,
        branchName?: (string | null),
    ): CancelablePromise<BranchListOutSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/provider/{provider_id}/branches/advanced',
            path: {
                'provider_id': providerId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'branch_name': branchName,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Provider
     * @param requestBody
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public postSPProvidersCreateProvider(
        requestBody: ProviderIn,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/sp/providers/new',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Provider Picture
     * Add a picture to the provider.
     *
     * Parameters:
     * - provider: The provider object to update.
     * - db: The database session.
     * - attachment: The image file to upload.
     *
     * Returns:
     * The updated provider object with the new picture.
     *
     * Raises:
     * - HTTPException(400): If the attachment is not a JPEG or PNG image, or if it is not a square image.
     * @param providerId
     * @param formData
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public patchSPProvidersAddProviderPicture(
        providerId: number,
        formData: Body_add_provider_picture_v1_sp_providers_provider__provider_id__add_picture_patch,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/provider/{provider_id}/add_picture',
            path: {
                'provider_id': providerId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider Branches
     * # THIS IS A DEPRECATING ENDPOINT
     *
     * Please refer to `/provider/{provider_id}/branches/advanced` instead.
     *
     * This endpoint is slow, the above referred enpoint has built in pagination, making it faster.
     * @param providerId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetProviderBranches(
        providerId: number,
    ): CancelablePromise<Array<SimpleBranch>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/provider/{provider_id}/branches',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branches
     * @param nameSearch
     * @param lat
     * @param lon
     * @param distance
     * @param limit
     * @param offset
     * @param allowIncomplete
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetBranches(
        nameSearch?: (string | null),
        lat?: (number | null),
        lon?: (number | null),
        distance?: (number | null),
        limit: number = 30,
        offset?: number,
        allowIncomplete: boolean = false,
    ): CancelablePromise<Array<SimpleBranch>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/branches',
            query: {
                'name_search': nameSearch,
                'lat': lat,
                'lon': lon,
                'distance': distance,
                'limit': limit,
                'offset': offset,
                'allow_incomplete': allowIncomplete,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branch
     * @param branchId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetBranch(
        branchId: number,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/branch/{branch_id}',
            path: {
                'branch_id': branchId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Branch
     * @param branchId
     * @param requestBody
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public patchSPProvidersEditBranch(
        branchId: number,
        requestBody: BranchEdit,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/branch/{branch_id}',
            path: {
                'branch_id': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Branch
     * @param branchId
     * @returns GenericStatus Successful Response
     * @throws ApiError
     */
    public deleteSPProvidersDeleteBranch(
        branchId: number,
    ): CancelablePromise<GenericStatus> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/sp/providers/branch/{branch_id}',
            path: {
                'branch_id': branchId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branch Detailed
     * @param branchId
     * @returns BaseBranch Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetBranchDetailed(
        branchId: number,
    ): CancelablePromise<BaseBranch> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/branch/{branch_id}/detailed',
            path: {
                'branch_id': branchId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Branch
     * @param providerId
     * @param requestBody
     * @param delayLocation
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public postSPProvidersCreateBranch(
        providerId: number,
        requestBody: BranchIn,
        delayLocation: boolean = false,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/sp/providers/branch/new/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            query: {
                'delay_location': delayLocation,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Branch Provider
     * @param branchId
     * @param providerId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public patchSPProvidersChangeBranchProvider(
        branchId: number,
        providerId: number,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/branch/{branch_id}/change_provider/{provider_id}',
            path: {
                'branch_id': branchId,
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Branch Location
     * @param branchId
     * @param requestBody
     * @returns BaseBranch Successful Response
     * @throws ApiError
     */
    public patchSPProvidersChangeBranchLocation(
        branchId: number,
        requestBody: UserLocationIn,
    ): CancelablePromise<BaseBranch> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/branch/{branch_id}/change_location',
            path: {
                'branch_id': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Incomplete Branches
     * @returns SimpleBranchWithCompletionStatus Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetAllIncompleteBranches(): CancelablePromise<Array<SimpleBranchWithCompletionStatus>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/branches/incomplete/all',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
            },
        });
    }
    /**
     * Make Branch Complete
     * Make a branch complete, This means that the branch is ready to be used. Incomplete branches stem from importing them from the job-csv.
     *
     * This endpoint makes a new location based on the given UserLocationIn model.
     *
     * Args:
     *
     * - `new_branch_location`: The new location of the branch.
     *
     * - `description`: The new description of the branch.
     *
     * - `branch`: The branch to make complete.
     *
     * Returns:
     *
     * - The updated branch in `SimpleBranch` model
     *
     * Warning:
     *
     * - This is a slower endpoint, because it performs an external API call to get the coordinates of the location based on the zipcode.
     * @param branchId
     * @param description
     * @param requestBody
     * @returns SimpleBranchWithCompletionStatus Successful Response
     * @throws ApiError
     */
    public patchSPProvidersMakeBranchComplete(
        branchId: number,
        description: string,
        requestBody: UserLocationIn,
    ): CancelablePromise<SimpleBranchWithCompletionStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/branch/{branch_id}/make_complete',
            path: {
                'branch_id': branchId,
            },
            query: {
                'description': description,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Department To Branch
     * @param branchId
     * @param newDepartmentName
     * @param newDepartmentCostCode
     * @returns BranchWithDepartments Successful Response
     * @throws ApiError
     */
    public patchSPProvidersAddDepartmentToBranch(
        branchId: number,
        newDepartmentName: string,
        newDepartmentCostCode: string,
    ): CancelablePromise<BranchWithDepartments> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/sp/providers/branch/{branch_id}/add_department',
            path: {
                'branch_id': branchId,
            },
            query: {
                'new_department_name': newDepartmentName,
                'new_department_cost_code': newDepartmentCostCode,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Worked Branches
     * ### Get Worked Branches
     *
     * Retrieve the branches a coach has worked at.
     *
     * **Permissions Required**:
     * `view_worked_branches`
     * ***found in:***
     * - `permission:can_manage_coaches`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **coach_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - A list of branches in `SimpleBranch` model.
     * @param coachId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSPProvidersGetWorkedBranches(
        coachId: number,
    ): CancelablePromise<Array<SimpleBranch>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/sp/providers/coach/{coach_id}/worked_branches',
            path: {
                'coach_id': coachId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Providers
     * @param nameSearch
     * @param orderBy
     * @param showInactive
     * @param orderAscending
     * @param limit
     * @param offset
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public getSpGetProvidersVLatest(
        nameSearch?: (string | null),
        orderBy?: (OrderByProvidersEnum | null),
        showInactive: boolean = true,
        orderAscending: boolean = true,
        limit: number = 30,
        offset?: number,
    ): CancelablePromise<Array<SimpleProvider>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/providers',
            query: {
                'name_search': nameSearch,
                'order_by': orderBy,
                'show_inactive': showInactive,
                'order_ascending': orderAscending,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider
     * @param providerId
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public getSpGetProviderVLatest(
        providerId: number,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/provider/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Provider
     * @param providerId
     * @param requestBody
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public patchSpEditProviderVLatest(
        providerId: number,
        requestBody: ProviderEdit,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/provider/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Provider
     * @param providerId
     * @returns GenericStatus Successful Response
     * @throws ApiError
     */
    public deleteSpDeleteProviderVLatest(
        providerId: number,
    ): CancelablePromise<GenericStatus> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/latest/sp/providers/provider/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider Active Or Inactive
     * @param providerId
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public getSpGetProviderActiveOrInactiveVLatest(
        providerId: number,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/provider/{provider_id}/active_or_inactive',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider Detailed
     * @param providerId
     * @returns BaseProvider Successful Response
     * @throws ApiError
     */
    public getSpGetProviderDetailedVLatest(
        providerId: number,
    ): CancelablePromise<BaseProvider> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/provider/{provider_id}/detailed',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branches From Provider
     * ### Get the branches of a provider.
     *
     * This endpoint is used to get the branches of a provider. It is paginated and returns a list of branches.
     *
     * Args:
     * - `provider_id`: The id of the provider to get the branches from.
     * - `limit`: The number of branches to return.
     * - `offset`: The number of branches to skip.
     *
     * Returns:
     * - A list of branches in `BranchListOutSchema` model.
     * @param providerId
     * @param limit
     * @param offset
     * @param branchName
     * @returns BranchListOutSchema Successful Response
     * @throws ApiError
     */
    public getSpGetBranchesFromProviderVLatest(
        providerId: number,
        limit: number = 30,
        offset?: number,
        branchName?: (string | null),
    ): CancelablePromise<BranchListOutSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/provider/{provider_id}/branches/advanced',
            path: {
                'provider_id': providerId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'branch_name': branchName,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Provider
     * @param requestBody
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public postSpCreateProviderVLatest(
        requestBody: ProviderIn,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/latest/sp/providers/new',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Provider Picture
     * Add a picture to the provider.
     *
     * Parameters:
     * - provider: The provider object to update.
     * - db: The database session.
     * - attachment: The image file to upload.
     *
     * Returns:
     * The updated provider object with the new picture.
     *
     * Raises:
     * - HTTPException(400): If the attachment is not a JPEG or PNG image, or if it is not a square image.
     * @param providerId
     * @param formData
     * @returns SimpleProvider Successful Response
     * @throws ApiError
     */
    public patchSpAddProviderPictureVLatest(
        providerId: number,
        formData: Body_add_provider_picture_latest_sp_providers_provider__provider_id__add_picture_patch,
    ): CancelablePromise<SimpleProvider> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/provider/{provider_id}/add_picture',
            path: {
                'provider_id': providerId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Provider Branches
     * # THIS IS A DEPRECATING ENDPOINT
     *
     * Please refer to `/provider/{provider_id}/branches/advanced` instead.
     *
     * This endpoint is slow, the above referred enpoint has built in pagination, making it faster.
     * @param providerId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSpGetProviderBranchesVLatest(
        providerId: number,
    ): CancelablePromise<Array<SimpleBranch>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/provider/{provider_id}/branches',
            path: {
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branches
     * @param nameSearch
     * @param lat
     * @param lon
     * @param distance
     * @param limit
     * @param offset
     * @param allowIncomplete
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSpGetBranchesVLatest(
        nameSearch?: (string | null),
        lat?: (number | null),
        lon?: (number | null),
        distance?: (number | null),
        limit: number = 30,
        offset?: number,
        allowIncomplete: boolean = false,
    ): CancelablePromise<Array<SimpleBranch>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/branches',
            query: {
                'name_search': nameSearch,
                'lat': lat,
                'lon': lon,
                'distance': distance,
                'limit': limit,
                'offset': offset,
                'allow_incomplete': allowIncomplete,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branch
     * @param branchId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSpGetBranchVLatest(
        branchId: number,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/branch/{branch_id}',
            path: {
                'branch_id': branchId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Branch
     * @param branchId
     * @param requestBody
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public patchSpEditBranchVLatest(
        branchId: number,
        requestBody: BranchEdit,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/branch/{branch_id}',
            path: {
                'branch_id': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Branch
     * @param branchId
     * @returns GenericStatus Successful Response
     * @throws ApiError
     */
    public deleteSpDeleteBranchVLatest(
        branchId: number,
    ): CancelablePromise<GenericStatus> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/latest/sp/providers/branch/{branch_id}',
            path: {
                'branch_id': branchId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Branch Detailed
     * @param branchId
     * @returns BaseBranch Successful Response
     * @throws ApiError
     */
    public getSpGetBranchDetailedVLatest(
        branchId: number,
    ): CancelablePromise<BaseBranch> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/branch/{branch_id}/detailed',
            path: {
                'branch_id': branchId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Branch
     * @param providerId
     * @param requestBody
     * @param delayLocation
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public postSpCreateBranchVLatest(
        providerId: number,
        requestBody: BranchIn,
        delayLocation: boolean = false,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/latest/sp/providers/branch/new/{provider_id}',
            path: {
                'provider_id': providerId,
            },
            query: {
                'delay_location': delayLocation,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Branch Provider
     * @param branchId
     * @param providerId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public patchSpChangeBranchProviderVLatest(
        branchId: number,
        providerId: number,
    ): CancelablePromise<SimpleBranch> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/branch/{branch_id}/change_provider/{provider_id}',
            path: {
                'branch_id': branchId,
                'provider_id': providerId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change Branch Location
     * @param branchId
     * @param requestBody
     * @returns BaseBranch Successful Response
     * @throws ApiError
     */
    public patchSpChangeBranchLocationVLatest(
        branchId: number,
        requestBody: UserLocationIn,
    ): CancelablePromise<BaseBranch> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/branch/{branch_id}/change_location',
            path: {
                'branch_id': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Incomplete Branches
     * @returns SimpleBranchWithCompletionStatus Successful Response
     * @throws ApiError
     */
    public getSpGetAllIncompleteBranchesVLatest(): CancelablePromise<Array<SimpleBranchWithCompletionStatus>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/branches/incomplete/all',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
            },
        });
    }
    /**
     * Make Branch Complete
     * Make a branch complete, This means that the branch is ready to be used. Incomplete branches stem from importing them from the job-csv.
     *
     * This endpoint makes a new location based on the given UserLocationIn model.
     *
     * Args:
     *
     * - `new_branch_location`: The new location of the branch.
     *
     * - `description`: The new description of the branch.
     *
     * - `branch`: The branch to make complete.
     *
     * Returns:
     *
     * - The updated branch in `SimpleBranch` model
     *
     * Warning:
     *
     * - This is a slower endpoint, because it performs an external API call to get the coordinates of the location based on the zipcode.
     * @param branchId
     * @param description
     * @param requestBody
     * @returns SimpleBranchWithCompletionStatus Successful Response
     * @throws ApiError
     */
    public patchSpMakeBranchCompleteVLatest(
        branchId: number,
        description: string,
        requestBody: UserLocationIn,
    ): CancelablePromise<SimpleBranchWithCompletionStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/branch/{branch_id}/make_complete',
            path: {
                'branch_id': branchId,
            },
            query: {
                'description': description,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Department To Branch
     * @param branchId
     * @param newDepartmentName
     * @param newDepartmentCostCode
     * @returns BranchWithDepartments Successful Response
     * @throws ApiError
     */
    public patchSpAddDepartmentToBranchVLatest(
        branchId: number,
        newDepartmentName: string,
        newDepartmentCostCode: string,
    ): CancelablePromise<BranchWithDepartments> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/sp/providers/branch/{branch_id}/add_department',
            path: {
                'branch_id': branchId,
            },
            query: {
                'new_department_name': newDepartmentName,
                'new_department_cost_code': newDepartmentCostCode,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Worked Branches
     * ### Get Worked Branches
     *
     * Retrieve the branches a coach has worked at.
     *
     * **Permissions Required**:
     * `view_worked_branches`
     * ***found in:***
     * - `permission:can_manage_coaches`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **coach_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - A list of branches in `SimpleBranch` model.
     * @param coachId
     * @returns SimpleBranch Successful Response
     * @throws ApiError
     */
    public getSpGetWorkedBranchesVLatest(
        coachId: number,
    ): CancelablePromise<Array<SimpleBranch>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/sp/providers/coach/{coach_id}/worked_branches',
            path: {
                'coach_id': coachId,
            },
            errors: {
                300: `Popup notification`,
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
}
